import React, { createContext, useContext, useRef } from 'react';
import ConfirmationPopUp from '../../components/UI/ConfirmationPopUp';

const DialogContext = createContext();

function DialogProvider({ children }) {
  const confirmationRef = useRef();
  const confirmationSecondaryRef = useRef();
  const value = React.useMemo(
    () => ({ confirmationRef, confirmationSecondaryRef }),
    [],
  );
  return (
    <DialogContext.Provider value={value}>
      {children}
      <ConfirmationPopUp reference={confirmationRef} />
      <ConfirmationPopUp reference={confirmationSecondaryRef} />
    </DialogContext.Provider>
  );
}

export const useDialog = () => {
  const { confirmationRef, confirmationSecondaryRef } =
    useContext(DialogContext);

  return {
    confirmationRef,
    confirmationSecondaryRef,
  };
};

export default DialogProvider;
